// src/navigation/publicAboutRoutes.js

export const aboutRoutes = Object.freeze([
  {
    id: 'about-overview',
    label: 'About All-Voiced',
    shortLabel: 'Overview',
    translationKey: 'about_all_voiced',
    path: '/about',
  },
  {
    id: 'listening-revolution',
    label: 'The Listening Revolution',
    translationKey: 'listening_revolution',
    path: '/listening-revolution',
  },
  {
    id: 'collaborations',
    label: 'Collaborations',
    translationKey: 'collaborations',
    path: '/collaborations',
  },
  {
    id: 'acknowledgements',
    label: 'Acknowledgements',
    translationKey: 'acknowledgements',
    path: '/acknowledgements',
    placement: 'footer',
  },
  {
    id: 'credits-and-citations',
    label: 'Credits & Citations',
    translationKey: 'credits_and_citations',
    path: '/credits',
    placement: 'footer',
  },
]);

export const aboutHeaderRoutes = Object.freeze(
  aboutRoutes.filter((route) => route.placement !== 'footer')
);

export const aboutFooterRoutes = aboutRoutes;

export const aboutRoutePaths = Object.freeze(
  aboutRoutes.map((route) => route.path)
);

export const aboutRoutesById = Object.freeze(
  aboutRoutes.reduce((routesById, route) => {
    routesById[route.id] = route;
    return routesById;
  }, {})
);

export function isAboutRoutePath(pathname = '') {
  return aboutRoutePaths.some((path) => (
    pathname === path || pathname.startsWith(`${path}/`)
  ));
}
